export default {
  QUEUED: 0,
  COMPLETE: 1,
  INPROGRESS: 2,
};
